export const getKpis = (state) => {
  return state.kpi.items;
};
